import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid2';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

import { useCookies } from 'react-cookie';

import axios from "axios";
import Swal from 'sweetalert2';

import { TextField } from '@mui/material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function ModalCrearProyecto(params) {
    axios.defaults.withCredentials = true;

    const [cookies, setCookie] = useCookies(["proyecto"]);
    const base = {
        "nombre": "",
        "ubicacion": ""
    }

    const [proyecto, setProyecto] = React.useState({
        "nombre": "",
        "ubicacion": ""
    });

    const [open, setOpen] = React.useState(false);    

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        handleClose();
        setProyecto(base);
    }

    const handleChangeData = (e) => {
        let tempproyecto = { ...proyecto };
        switch (e.target.name) {
            case "proyecto":
                tempproyecto.nombre = e.target.value;
                break;
            case "ubicacion":
                tempproyecto.ubicacion = e.target.value;
                break;
            default:
                break;
        }
        setProyecto(tempproyecto);
    }

    const handleSaveProyecto = () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Vas a crear un nuevo proyecto",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'CREAR',
        }).then((result) => {
            if (result.isConfirmed) {
                // El usuario hizo clic en "Sí"
                guardarProyecto();
            } else {
                // El usuario hizo clic en "No"
                Swal.fire({
                    title: 'Accion Cancelada',
                    icon: 'error',
                    text: "",
                    showConfirmButton: false,
                    timer: 1000
                });
            }
        });
    }

    const guardarProyecto = async () => {
        params.cargando("Guardando")
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/crear_proyecto.php",
                proyecto,
                { headers: { "Content-Type": "application/json" } }
            );

            // Verifica y almacena los datos recibidos
            if (response.data && response.data.status === "success") {
                // Subir la imagen solo si el artículo se guardó correctamente
                setCookie("proyecto", "0", {
                    path: "/",
                    maxAge: 99000000
                })
                handleClose();
                setProyecto(base)
                Swal.fire({
                    title: 'Proyecto Creado',
                    text: 'El proyecto fue creado con exito.',
                    icon: 'success',
                    timer: 1000,
                    showConfirmButton: false,
                });
                params.fetchUltimoProyecto("ultimo")                


            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo guardar el proyecto.',
                    icon: 'error'
                });
            }
        } catch (err) {
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al conectar con el servidor.',
                icon: 'error'
            });
        }
    };


    return (
        <React.Fragment>
            <IconButton color={params.color} aria-label="add" onClick={handleClickOpen}>
                <CreateNewFolderIcon />
            </IconButton>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Crear Proyecto
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid container spacing={2} rowSpacing={2} columns={10}>
                        <Grid size={{ xs: 10 }}>
                            <TextField
                                fullWidth
                                name='proyecto'
                                label='Proyecto'
                                variant='outlined'
                                value={proyecto.proyecto}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={{ xs: 10 }}>
                            <TextField
                                fullWidth
                                name='ubicacion'
                                label='Ubicacion'
                                variant='outlined'                                
                                value={proyecto.ubicacion}
                                onChange={handleChangeData}
                            />
                        </Grid>                                            
                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex", justifyContent:"space-between"}}>
                    <Button variant='outlined' color="error" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button variant='contained' onClick={handleSaveProyecto}>
                        Guardar
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ModalCrearProyecto;
